module.exports = __webpack_public_path__ + "img/merch.df3bb801.svg";